var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("create-revenue-source", {
                attrs: { "default-value": _vm.revenueSource },
                on: {
                  "update:defaultValue": function($event) {
                    _vm.revenueSource = $event
                  },
                  "update:default-value": function($event) {
                    _vm.revenueSource = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c("table-revenue-source", {
                model: {
                  value: _vm.revenueSource,
                  callback: function($$v) {
                    _vm.revenueSource = $$v
                  },
                  expression: "revenueSource"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }